import React, { useState, useEffect } from 'react';

import { SubscriptionPlan } from '@repo/domain/user';
import useFreeTrial from '@repo/editor/src/hooks/useFreeTrial';
import { withEventScope } from '@repo/event-processor';
import { IconButton } from '@repo/ui/components/Buttons';
import CloseIcon from '@repo/ui/components/Icon/CloseIcon';
import { Spacer } from '@repo/ui/components/Spacer';
import { H4, P2 } from '@repo/ui/components/Typography';
import { themeStyle } from '@repo/ui/theming';

import { LOCAL_STORAGE_FREE_TRIAL_SEEN_STATUS_KEY } from 'global/constants';
import { FlexContainer, FlexRow } from 'styles/layouts';

import Tip from '../../../Tip/Tip';

import { getInfoboxData, FreeTrialSeenStatus } from './data';

const iconButtonTheme = {
  color: themeStyle.varInkMedium,
  activeColor: themeStyle.varInkMain,
};

const tipTheme = {
  padding: '24px',
  width: 'calc(100% - 36px)',
};

const Infobox: React.FC<{ plan?: SubscriptionPlan }> = ({ plan }) => {
  const freeTrial = useFreeTrial();
  const [seenStatus, setSeenStatus] = useState<FreeTrialSeenStatus | null>(
    null
  );

  useEffect(() => {
    const status = localStorage.getItem(
      LOCAL_STORAGE_FREE_TRIAL_SEEN_STATUS_KEY
    ) as FreeTrialSeenStatus | null;
    setSeenStatus(status);
  }, []);

  const [title, text, status] = getInfoboxData(freeTrial, plan);

  if ((seenStatus && seenStatus === status) || !title || !text) {
    return null;
  }

  return (
    <>
      <Tip theme={tipTheme}>
        <FlexRow
          alignItems="center"
          gap="4px"
          style={{ flexGrow: 1, flexWrap: 'wrap' }}
        >
          <H4>{title}</H4>
          <P2>{text}</P2>
        </FlexRow>
        <FlexContainer
          alignItems="center"
          justifyContent="center"
          style={{ height: '21px' }}
        >
          <IconButton
            ariaLabel="close"
            height="16px"
            icon={CloseIcon}
            name="infoboxCloseButton"
            style={{ alignSelf: 'center' }}
            theme={iconButtonTheme}
            onClick={(): void => {
              setSeenStatus(status);
              localStorage.setItem(
                LOCAL_STORAGE_FREE_TRIAL_SEEN_STATUS_KEY,
                status!
              );
            }}
          />
        </FlexContainer>
      </Tip>
      <Spacer height="80px" />
    </>
  );
};

export default withEventScope(Infobox, {
  module: 'subscriptionPricingInfobox',
});
